'use strict'

document.addEventListener("DOMContentLoaded", function(event) {
    /********************************
     * Choose country
     *******************************/
    const countriesWrap = document.querySelector('.country-wrap_js');

    countriesWrap.addEventListener('click', ({target})=>{
        const formCountry = document.querySelector('.locale-selectors__container form');
        const switcherCountries = document.querySelectorAll('#country_code option');

        const country = target.closest('.country-item');
        const countryCode = country.dataset.country;

        if(formCountry && country.classList.contains('country-item')){

            switcherCountries.forEach(option => {
                if(option.getAttribute('value') === countryCode){
                    option.selected = true;
                    formCountry.submit();
                }
            });

        }else{

        }

    });
});